import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Modal, Spin } from 'antd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { green } from '@material-ui/core/colors';
import 'antd/dist/antd.css';
import Highlighter from 'react-highlight-words';
import './OutOfStockRecipientList.css';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../../admin/i18n/adminI18n';

const { Title } = Typography;

@inject('outOfStockRecipientStore')
@observer
class OutOfStockRecipientList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    createOrUpdateCategoryOnClick = () => this.props.outOfStockRecipientStore.createOrUpdateCategory();

    createClicked = () => this.props.outOfStockRecipientStore.initCreate();

    updateClicked = outOfStockRecipientId => this.props.outOfStockRecipientStore.initUpdate(outOfStockRecipientId);

    removeClicked = outOfStockRecipientId => this.props.outOfStockRecipientStore.deleteOutOfStockRecipient(outOfStockRecipientId);

    deleteClicked = outOfStockRecipientId => {
        const { t } = this.props;
        Modal.confirm({
            title: t('Remove Out of Stock Recipient'),
            content: t('Are you sure to remove out of stock recipient?'),
            okText: t('Remove'),
            cancelText: t('Cancel'),
            onOk: () => this.removeClicked(outOfStockRecipientId)
        });
    }

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Email'),
                dataIndex: 'email',
                key: 'email',
                ...this.getColumnSearchProps('email')
            },
            {
                title: t('Action'),
                dataIndex: 'outOfStockRecipientId',
                key: 'outOfStockRecipientId',
                render: outOfStockRecipientId => (
                    <span>
                        <Button onClick={() => this.updateClicked(outOfStockRecipientId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteClicked(outOfStockRecipientId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => {
        const { t } = this.props;
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            this.searchInput = node
                        }}
                        placeholder={`${t('Search')} ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type='primary'
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon='search'
                        size='small'
                        style={{ width: 90, marginRight: 8 }}
                    >
                        {t('Search')}
                </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                        {t('Reset')}
                </Button>
                </div>
            ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
        };
    };

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const { t } = this.props;
        const {
            outOfStockRecipients,
            listLoading,
        } = this.props.outOfStockRecipientStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20, marginTop: 20 }}>
                        <Title level={3} style={{ width: '80%', position: 'relative', float: 'left' }}>{t('List')}</Title>
                        <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createClicked}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Spin spinning={listLoading}>
                        <Table columns={this.getColumns()} dataSource={outOfStockRecipients} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(OutOfStockRecipientList);